import React, { useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PasswordStrength } from "@/components/PasswordStrength";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

export function ConvertGuestDialog({ open, onOpenChange }) {
  const { t, loginWithToken, user } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", first_name: "", last_name: "" });
  const [accept, setAccept] = useState(false);
  const [busy, setBusy] = useState(false);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!accept) { toast.error(t("mustAcceptTerms")); return; }
    setBusy(true);
    try {
      const email = form.email || user?.guest_email || "";
      const res = await api.post("/auth/convert-guest", { ...form, email });
      loginWithToken(res.data.token, res.data.user);
      toast.success(t("guestConvertSuccess"));
      onOpenChange(false);
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Fehler");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="convert-guest-dialog" className="max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading">{t("guestConvertTitle")}</DialogTitle>
          <DialogDescription className="mt-1">{t("guestConvertDesc")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="flex gap-3">
            <input data-testid="convert-firstname" className="sb-input" placeholder={t("firstName")} value={form.first_name} onChange={upd("first_name")} required />
            <input data-testid="convert-lastname" className="sb-input" placeholder={t("lastName")} value={form.last_name} onChange={upd("last_name")} />
          </div>
          <input data-testid="convert-email" type="email" className="sb-input" placeholder={t("email")} value={form.email} onChange={upd("email")} required />
          <input data-testid="convert-password" type="password" className="sb-input" placeholder={t("password")} value={form.password} onChange={upd("password")} required />
          <PasswordStrength value={form.password} />
          <label className="flex items-start gap-2 cursor-pointer">
            <input data-testid="convert-accept-terms" type="checkbox" className="mt-0.5 h-4 w-4 accent-[var(--app-primary)]" checked={accept} onChange={(e) => setAccept(e.target.checked)} />
            <span className="font-body text-xs text-gray-600">
              Ich akzeptiere die <a href="/terms" target="_blank" rel="noreferrer" className="underline">Nutzungsbedingungen</a> und die <a href="/privacy" target="_blank" rel="noreferrer" className="underline">Datenschutzerklärung</a>.
            </span>
          </label>
          <button data-testid="convert-submit" type="submit" disabled={busy || !accept}
            className="sb-btn w-full py-3.5 text-white font-medium disabled:opacity-60" style={{ background: "var(--app-primary)" }}>
            {busy ? "…" : t("convertCreate")}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
